module.exports = __webpack_public_path__ + "static/Tritech-970f6324515e5078a94b5058ed58027e.svg";